import { useDispatch, useSelector } from "react-redux";
import { pusher } from "@common/services/socketCommution";
import { reducerPaths } from "../../../../../app/reducerPaths";
import { USER_ROLES } from "../../../../../utils/constants/userRoles";
import React from "react";

const useCarsInNegotiationSocketEvents = ({
  sellerId,
  dealerId,
  Vehicle_Id,
  selectedVehicle,
  myCarsOrOtherCars,
  onNewCounterOfferHandler,
  onBidAcceptedHandler,
  onBidDeclinedHandler
}) => {

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const carsInNegotiation = useSelector(store => store[reducerPaths.carsInNegotiation]);
  const auth = useSelector(store => store[reducerPaths.auth]);
  // useSelector end...

  // Handlers start...
  const onBidAcceptedListener = (e) => {
    console.log(`onBidAcceptedListener`, e);

    if (auth?.user_role === USER_ROLES.agent && auth?.user_id !== selectedVehicle?.Agent_Id) {
      return;
    }

    if (parseInt(e?.vehicleId) !== selectedVehicle?.Vehicle_Id) {
      return;
    }

    if (onBidAcceptedHandler) {
      onBidAcceptedHandler(e);
    }
    // if (onNewBidHandler) {
    //   onNewBidHandler();
    // }
    // let newBidHistory = [
    //   {
    //     ...(e || {}),
    //     amount: e?.bidAmount,
    //     sellerId: e?.sellerId,
    //     Vehicle_Id: e?.vehicleId,
    //   },
    //   ...(liveAuction?.bidHistory?.data || []),
    // ];

    // console.log(newBidHistory, liveAuction?.bidHistory?.data, `newBidHistory`);
    // dispatch(
    //   setLiveAuctionMultipleFields({
    //     bidHistory: {
    //       ...liveAuction?.bidHistory,
    //       data: newBidHistory
    //     }
    //   })
    // )
  };

  const onBidDeclinedListener = (e) => {
    console.log(`onBidDeclinedListener`, e);
    if (onBidDeclinedHandler) {
      onBidDeclinedHandler(e);
    }
  };

  const onCounterOfferSentListener = (e) => {
    console.log(`onCounterOfferSentListener`, e);
    if (onNewCounterOfferHandler) {
      onNewCounterOfferHandler(e);
    }
  };
  // Handlers end...


  // useEffect start...
  React.useEffect(() => {
    let adminChannel;
    let sellerChannel;
    let dealerChannel;
    
    sellerChannel = pusher.subscribe(`seller.${sellerId}`);
    adminChannel = pusher.subscribe(`admin.${selectedVehicle?.auction_type}`);
    const privateBidDeclinedChannel = pusher.subscribe(`bid.declined.${Vehicle_Id}`);
    const counterOfferSellerIdChannel = pusher.subscribe(`dealer-counter.${sellerId}`);
    const counterOfferDealerIdChannel = pusher.subscribe(`dealer-counter.${dealerId}`);

    adminChannel.bind(`App\\Events\\BidAcceptedSeller`, onBidAcceptedListener);
    sellerChannel.bind(`App\\Events\\BidAcceptedSeller`, onBidAcceptedListener);
    privateBidDeclinedChannel.bind(`App\\Events\\BidDeclined`, onBidDeclinedListener);
    counterOfferSellerIdChannel.bind(`counter-offer.sent`, onCounterOfferSentListener);
    counterOfferDealerIdChannel.bind(`counter-offer.sent`, onCounterOfferSentListener);

    return () => {
      adminChannel.unbind(`App\\Events\\BidAcceptedSeller`, onBidAcceptedListener);
      sellerChannel.unbind(`App\\Events\\BidAcceptedSeller`, onBidAcceptedListener);
      privateBidDeclinedChannel.unbind(`App\\Events\\BidDeclined`, onBidDeclinedListener);
      counterOfferSellerIdChannel.unbind(`counter-offer.sent`, onCounterOfferSentListener);
      counterOfferDealerIdChannel.bind(`counter-offer.sent`, onCounterOfferSentListener);
    }
  }, [sellerId, dealerId, Vehicle_Id, selectedVehicle]);
  // useEffect end...

};  

export {
  useCarsInNegotiationSocketEvents
};